import axios from 'axios'

export const createContactAddress = async (contactAddress: any) => {
  return await axios.post(
    `${process.env.REACT_APP_API_URL}/contactAddress`,
    contactAddress,
    {
      withCredentials: true,
    },
  )
}
